let hasWarnedMissing = false;

export function getNewRelic() {
  // When explicitly disabled, fail silently to avoid noisy logs.
  if (process.env.NEXT_PUBLIC_NEW_RELIC_DISABLED === 'true') {
    return undefined;
  }

  if (typeof window !== 'undefined' && window.newrelic) {
    return window.newrelic;
  }

  // Avoid false-positive warnings during startup before scripts finish loading.
  if (typeof document !== 'undefined' && document.readyState !== 'complete') {
    return undefined;
  }

  if (!hasWarnedMissing) {
    hasWarnedMissing = true;
    // eslint-disable-next-line no-console
    console.warn('Failed to load New Relic');
  }

  return undefined;
}
